import {atom} from 'jotai';
import {MyData} from '@/interface';

export const userAtom = atom<MyData | undefined>(undefined);
